export const ShoppingListPage = () => {
    return (
        <div className="pagecontent">
            <h1>Список покупок</h1>
        </div>
    )
}